import iframeResize from './iframe-resizer'

document.addEventListener("turbolinks:load", function() {
  let iframe = $('.mj-w-res-iframe')
  if (iframe.length > 0 ) {
    iframeResize({ log: false }, iframe[0]);
  }
});